import classNames from "classnames";
import NumberFormat from "react-number-format";

interface IContactTableCountProps {
  offsetStart: number;
  offsetEnd: number;
  totalCount: number;
  selectedCount?: number;
}

const ContactTableCount = ({
  offsetStart,
  offsetEnd,
  totalCount,
  selectedCount = 0,
}: IContactTableCountProps) => {
  return (
    <div
      className={classNames(
        "text-sm",
        "pb-2",
        "text-neutral-500",
        "flex",
        "justify-end",
      )}
    >
      <div className={classNames("pl-2")}>
        <div className={classNames("flex", "flex-row")}>
          {selectedCount > 0 ? (
            <>
              <NumberFormat
                value={selectedCount}
                thousandSeparator=","
                displayType="text"
              />
              <span className={classNames("mx-1")}>of</span>
              <NumberFormat
                value={totalCount}
                thousandSeparator=","
                displayType="text"
              />
              <span className={classNames("ml-1")}>selected</span>
            </>
          ) : (
            <>
              Showing
              <div className={classNames("mx-1")}>
                <NumberFormat
                  value={offsetStart + 1}
                  thousandSeparator=","
                  displayType="text"
                />
                {"–"}
                <NumberFormat
                  value={Math.min(offsetEnd, totalCount)}
                  thousandSeparator=","
                  displayType="text"
                />
              </div>
              of
              <NumberFormat
                value={totalCount}
                thousandSeparator=","
                displayType="text"
                className={classNames("pl-1")}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactTableCount;
